import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiDownloadFile = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M12 17L16 13L14.6 11.6L13 13.15V9H11V13.15L9.4 11.6L8 13L12 17ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V8L10 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM6 20H18V4H10.85L6 8.85V20Z"/>
  </SvgWrapper>
)
